module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-container"
  }, [_c('div', {
    staticClass: "indicator-wrapper"
  }, [_c('scroll-indicator', {
    attrs: {
      "color": "white"
    }
  })], 1), _vm._v(" "), (_vm.loader) ? _c('div', {
    staticClass: "loader-container"
  }, [_c('v-layout', {
    attrs: {
      "fill-height": "",
      "align-center": "",
      "justify-center": "",
      "ma-0": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "grey lighten-5"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inner-display"
  }, _vm._l((_vm.$store.state.jewelry), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "jewelry-card",
      staticStyle: {
        "margin": "1rem"
      },
      attrs: {
        "tile": ""
      }
    }, [_c('v-card-title', {
      attrs: {
        "primary-title": ""
      }
    }, [_c('div', [_c('h3', {
      staticStyle: {
        "font-family": "'DINPro Regular'"
      },
      attrs: {
        "center": ""
      }
    }, [_vm._v(_vm._s(item.title))])])]), _vm._v(" "), _c('v-img', {
      staticClass: "jewelry-image",
      attrs: {
        "src": item.imageUrl,
        "lazy-src": item.imageUrl,
        "aspect-ratio": "1"
      },
      scopedSlots: _vm._u([{
        key: "placeholder",
        fn: function() {
          return [_c('v-layout', {
            attrs: {
              "fill-height": "",
              "align-center": "",
              "justify-center": "",
              "ma-0": ""
            }
          }, [_c('v-progress-circular', {
            attrs: {
              "indeterminate": "",
              "color": "grey lighten-5"
            }
          })], 1)]
        },
        proxy: true
      }], null, true)
    })], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c29cb7ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collections/ViewCollection.vue
// module id = 224
// module chunks = 1